import { render, staticRenderFns } from "./JoinToBHCModule.vue?vue&type=template&id=7ff91e82&scoped=true"
import script from "./JoinToBHCModule.vue?vue&type=script&lang=js"
export * from "./JoinToBHCModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff91e82",
  null
  
)

export default component.exports